import { ref } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia';
import { usePlayMixStore } from '~/stores/usePlayMixStore';

const playmix = (hubbleClient) => {
  const selected = ref([]);
  const selection = ref([]);
  const data = ref(null)
  let currentBundleId = null
  const playMixStore = usePlayMixStore()
  const {
    selectedPlayServices
  } = storeToRefs(playMixStore)
  const getPlayMixServices = async (bundleId) => {
    // Refetch when bundle changes to avoid stale data when navigating back/forward
    if (data.value && currentBundleId === bundleId) { return }
    const res = await hubbleClient.playMix.getPlayMixServices(bundleId);
    data.value = res.data
    currentBundleId = bundleId
    // reset local models for new bundle context
    selected.value = []
    setInitialSelection(data.value.mixVasLimit)
    // clear committed selection to avoid sending stale mix products
    selectedPlayServices.value = []
    return res;
  }

  const setInitialSelection = (limit) => {
    selection.value = new Array(limit).fill(null);
  }
  const validatePlayMixServicesInCart = async (mixProductsInCart, bundleId) => {
    await getPlayMixServices(bundleId)
    // let allValidServices = true
    // mixProductsInCart.forEach(mixProduct => {
    //   if (data.value.productOfferingDTOWithContent.find(po => po.productOfferingDTO.id === mixProduct) === undefined) {
    //     allValidServices = false
    //     console.log('[validatePlayMixServicesInCart] invalid product (not in offering)', { mixProduct, offeredIds })
    //   }
    // })
    mixProductsInCart = [...new Set(mixProductsInCart)]
    return data.value.mixVasLimit === mixProductsInCart.length
  }
  return {
    validatePlayMixServicesInCart,
    selectedPlayServices,
    getPlayMixServices,
    data,
    selected,
    selection
  }
}

export default function (identifier, appContext) {
  const playMixStore = usePlayMixStore()
  if (playMixStore.mixes[identifier]) {
    return playMixStore.mixes[identifier]
  }
  playMixStore.mixes[identifier] = playmix(appContext)
  return playMixStore.mixes[identifier]
}
